import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DocumentDetailModule } from '../document-detail/document-detail.module';
import { EntityMasterModule } from '../entity-master/entity-master.module';
import { FormMasterModule } from '../form-master/form-master.module';
import { InvoiceDataModule } from '../invoice-data/invoice-data.module';
import { SharedModule } from '../shared/shared.module';
import { AddTrackedTimeComponent } from './components/add-tracked-time/add-tracked-time.component';
import { BilledTrackedTimeListComponent } from './components/billed-tracked-time-list/billed-tracked-time-list.component';
import { SearchTrackedTimeListComponent } from './components/search-tracked-time-list/search-tracked-time-list.component';
import { TrackedTimeListItemComponent } from './components/tracked-time-list-item/tracked-time-list-item.component';
import { TrackedTimeListComponent } from './components/tracked-time-list/tracked-time-list.component';
import { UnbilledTrackedTimeListComponent } from './components/unbilled-tracked-time-list/unbilled-tracked-time-list.component';
import { TrackedTimeMasterComponent } from './tracked-time-master.component';
import { ToasterModule } from '../toaster/toaster.module';
import { DialogModule } from '../dialog/dialog.module';

const internalComponents = [
  TrackedTimeMasterComponent,
  UnbilledTrackedTimeListComponent,
  BilledTrackedTimeListComponent,
  TrackedTimeListComponent,
  TrackedTimeListItemComponent,
];

const exportableComponents = [
  AddTrackedTimeComponent,
  SearchTrackedTimeListComponent,
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ToasterModule,
    FormMasterModule,
    EntityMasterModule,
    DocumentDetailModule,
    InvoiceDataModule,
    DialogModule,
  ],
  declarations: [...internalComponents, ...exportableComponents],
  exports: [...exportableComponents],
})
export class TrackedTimeMasterModule {}
